import { render, staticRenderFns } from "./LightboxImage.vue?vue&type=template&id=607fb04d&"
import script from "./LightboxImage.vue?vue&type=script&lang=js&"
export * from "./LightboxImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_y5o36p7qrshhm4v7l6yk7rwfsu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports